/**
 * Переключение между старой (2dchat.system123.ru) и новой (2dchat.test.system123.ru) 2Д-зонами.
 * Cookie `zone_preference` на домене `.system123.ru`.
 */

const COOKIE_NAME = "zone_preference";
const COMPANY_COOKIE_NAME = "selected_company_id";
const OLD_ZONE_HOST = "2dchat.system123.ru";
const NEW_ZONE_HOST = "2dchat.test.system123.ru";

function getCookieDomain() {
  const host = location.hostname;
  if (host === "localhost" || host === "127.0.0.1" || /^\d+\.\d+\.\d+\.\d+$/.test(host)) return "";
  const parts = host.split(".");
  if (parts.length >= 2) return "." + parts.slice(-2).join(".");
  return "";
}

export function getZonePreference() {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`));
  const val = match?.[1];
  if (val === "new" || val === "old") return val;
  return "none";
}

export function setZonePreference(pref) {
  const domain = getCookieDomain();
  const domainStr = domain ? `; domain=${domain}` : "";
  const maxAge = pref === "none" ? 0 : 365 * 24 * 60 * 60;
  document.cookie = `${COOKIE_NAME}=${pref}; path=/${domainStr}; max-age=${maxAge}; SameSite=Lax`;
}

export function getSharedCompanyId() {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COMPANY_COOKIE_NAME}=([^;]*)`));
  const companyId = Number(match?.[1]);
  return Number.isInteger(companyId) && companyId > 0 ? companyId : null;
}

export function setSharedCompanyId(companyId) {
  const domain = getCookieDomain();
  const domainStr = domain ? `; domain=${domain}` : "";
  const secure = location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COMPANY_COOKIE_NAME}=${companyId}; path=/${domainStr}; max-age=${365 * 24 * 60 * 60}; SameSite=Lax${secure}`;
}

export function isNewZone() {
  return location.hostname === NEW_ZONE_HOST;
}

export function isOldZone() {
  return location.hostname === OLD_ZONE_HOST;
}

export function checkZoneRedirect() {
  const pref = getZonePreference();
  if (pref === "none") return false;
  if (pref === "new" && isOldZone()) {
    location.replace(`${location.protocol}//${NEW_ZONE_HOST}`);
    return true;
  }
  if (pref === "old" && isNewZone()) {
    location.replace(`${location.protocol}//${OLD_ZONE_HOST}`);
    return true;
  }
  return false;
}

// 2dchat = старая зона, переход всегда на новую
export function switchToOtherZone() {
  const pref = getZonePreference();
  if (pref !== "none") {
    setZonePreference("new");
  }
  location.href = `${location.protocol}//${NEW_ZONE_HOST}`;
}
